import type { IntakeTemplate } from '../templateTypes';
import { templatePriseDeBesoinClient2026 } from './prise-de-besoin-client-2026';

export const templatePriseDeBesoinClient2026Analyse: IntakeTemplate = {
  ...templatePriseDeBesoinClient2026,
  id: 'prise-de-besoin-client-2026-analyse',
  name: 'Prise de besoin - Maturité et besoins client — Analyse & recommandations',
  description:
    'Espace de production du document narratif Analyse & recommandations à partir du formulaire Prise de besoin - Maturité et besoins client. Structure les constats, priorités, risques, recommandations et prochaines étapes sans inventer de faits client.',
  documentTypeCode: 'PRISE_BESOIN_CLIENT_2026_ANALYSE',
};
